package de.oevbs.kunde.kundenportal2.authentication.components

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.forms.inputgroup.inputText
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kosmos.ui.icons.icon
import de.oevbs.kosmos.ui.layouts.card
import de.oevbs.kunde.kundenportal2.Formats
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.authentication.*
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.navigation.visit
import de.oevbs.kunde.kundenportal2.services.consent.ConsentClient
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import dev.fritz2.core.*
import dev.fritz2.headless.components.popOver
import dev.fritz2.headless.foundation.utils.floatingui.core.middleware.offset
import dev.fritz2.headless.foundation.utils.floatingui.utils.PlacementValues
import kotlinx.coroutines.flow.filter

fun RenderContext.loginForm() {
    headerImageLayout {
        headerImage = "images/headers/anmeldung.jpg"
        title("Anmeldung in Meine Öffentliche")
        content {
            div("grid grid-cols-1 xl:grid-cols-[5fr_3fr] gap-8") {
                renderLoginSection()
                renderRegistrationCard()
            }
        }
    }
}

private fun RenderContext.renderLoginSection() {

    val loginDataStore = LoginDataStore(job)

    loginDataStore.handleAuthentication handledBy { loggedInUser ->
        //Nach dem Login nur bei vertragverknüpften Usern prüfen, ob sie ihre Einwilligungserklärungen bereits bearbeitet haben
        if (hasAuthority(loggedInUser, PortalAuthority.PinAuthenticated))
            if (tryCatchAndHandleErrors("Prüfen des Status der Einwilligungserklärung") {
                    ConsentClient().check()
                } == true) {
                contentToast {
                    imageRoute(
                        "w-56 md:w-72 rounded drop-shadow-lg",
                        "Ein Bild von einer Frau mit einem Mobiltelefon und dem Text 'Bleiben Sie informiert - erteilen Sie uns Ihre Einwilligung!'",
                        "images/other/ConsentReminder.png"
                    ) handledBy { Pages.myDataConsent.visit() }
                }
            }
    }

    /**
     * Nach dem Login kann statt dem Consent-Reminder oben auch mal eine Anzeige geschaltet werden, die dem User nur dann
     * angezeigt wird, wenn er sie noch nicht gesehen hat (Merken per LocalStorage).
     */
// loginDataStore.handleAuthentication handledBy {
//        if (!hasSeenDialog(PortalSession.current?.username, digiCardAd)) {
//            contentToast {
//                imageRoute(
//                    "w-56 md:w-72 rounded drop-shadow-lg",
//                    "Ein Foto von einer Frau, die ein Mobiltelefon hält. Der Text auf dem Bild sagt: Holen Sie sich Ihre digitale Kfz-Servicekarte - hier klicken und anfordern.",
//                    "images/other/NachLoginDigiCardAd.jpg"
//                ) handledBy { Pages.serviceCarInsuranceDigiCard.visit() }
//            }
//            setHasSeenDialog(PortalSession.current?.username, digiCardAd)
//        }
//    }

    div("w-full py-2 grow flex flex-col gap-4") {
        div {
            +"Um das Kundenportal "
            span("font-semibold") { +"Meine Öffentliche" }
            +" nutzen zu können, müssen Sie sich anmelden."
            br {}
            +"""Bitte geben Sie Ihren Benutzernamen und Ihr Passwort ein. Den Benutzernamen finden Sie
                in der Willkommens-Mail, die Sie im Anschluss an die Registrierung erhalten haben."""
        }

        inputText {
            label("Benutzername")
            value(loginDataStore.map(UserLoginData.username() + Formats.trimString))
            iconClickableWithPopover(MaterialIconsOutlined.help, HelpPopovers.usernameEmpty)
        }.keyups.filter { shortcutOf(it) == Keys.Enter } handledBy loginDataStore.handleAuthentication

        inputPassword {
            label("Passwort")
            value(loginDataStore.map(UserLoginData.password()))
        }.keyups.filter { shortcutOf(it) == Keys.Enter } handledBy loginDataStore.handleAuthentication

        buttonContainer {
            btn {
                label("Anmelden")
                busy(globalSubmitTracker.data)
            }.clicks handledBy loginDataStore.handleAuthentication

            btn {
                label("Zugangsdaten vergessen?")
            }.clicks handledBy {
                Pages.reset.visit()
            }
        }
    }
}

private fun RenderContext.renderRegistrationCard() {

    card {
        div("flex flex-col gap-3") {

            sectionHeader("Sie haben noch keinen Account?")

            +"Registrieren Sie sich jetzt und nutzen Sie unsere Service-Angebote rund um die Uhr."
            ul("list-disc list-inside") {
                li {
                    +"Verträge und Postfach einsehen"
                }
                li {
                    +"Persönliche Daten bearbeiten"
                }
                li {
                    +".. und viele weitere Services"
                }
            }

            popOver {
                popOverButton {
                    tabIndex(-1)
                    div("flex flex-row items-center gap-1") {
                        icon("h-5 w-5 text-primary-500", icon = MaterialIconsOutlined.help)
                        span("text-sm text-primary-500 whitespace-nowrap") { +"Wer kann das Kundenportal nutzen?" }
                    }
                    popOverPanel("bg-primary-50 shadow rounded p-3 py-4 max-w-full md:max-w-96 z-10") {
                        placement = PlacementValues.bottomEnd
                        addMiddleware(offset {
                            mainAxis = 12
                            crossAxis = 0
                        })
                        transition(
                            opened,
                            "transition ease-out duration-200",
                            "opacity-0 translate-y-1",
                            "opacity-100 translate-y-0",
                            "transition ease-in duration-150",
                            "opacity-100 translate-y-0",
                            "opacity-0 translate-y-1"
                        )
                        arrow("h-6 w-6")
                        paragraph("text-sm") {
                            +"Meine Öffentliche steht aktuell nur Privatkunden mit der Anrede 'Herr' oder 'Frau' zur Verfügung."
                            +" Firmenkunden, Wohneigentümer- und Versicherungsnehmer-Gemeinschaften können derzeit leider nicht auf das Kundenportal zugreifen."
                        }
                        paragraph("text-sm") {
                            +"Beachten Sie bitte außerdem, dass für jede Partnernummer ein eigener Account notwendig ist."
                            +" Haushalte können derzeit nicht in einem gemeinsamen Account angezeigt werden."
                        }
                    }
                }
            }

            buttonContainer {
                btn {
                    label("Registrieren")
                }.clicks handledBy {
                    Pages.registration.visit()
                }
            }
        }
    }
}